var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"member"},[_c('BaseTable',{attrs:{"settings":_vm.settings,"fields":_vm.fields,"items":_vm.result,"searchTerm":_vm.$store.state.searchTerm,"sortBy":"familyname","sortOrder":"asc","rowClass":"familyname","tableId":"1"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4af6541e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Member.vue
// module id = 191
// module chunks = 1